import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AttendanceLogsDataTable from './AttendancesLogsDataTable';

const AttendanceLogsIndex = () => {
  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column ml-1">
              <h2 className="mt-3 text-uppercase">
                Log de Asistencias
              </h2>
            </div>
          </div>
        </Col>
      </Row>
      <AttendanceLogsDataTable />
    </>
  );
};

export default AttendanceLogsIndex;